import get from 'lodash/get';
import { createSelector } from 'reselect';
import { selectFeatureFlags } from './ContextSelector';

export const selectIsAccessibleV2Enabled = createSelector( // eslint-disable-line
    [selectFeatureFlags],
    (featureFlags) => get(featureFlags, 'isAccessibleV2Enabled', false)
);
